import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FormattedMessage} from "react-intl";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import Button from "../../../Button";
import api from "../../../../api";
import QuestionTemplateForm from "../QuestionTemplateForm";


class EditQuestionTemplate extends PureComponent {
  constructor(props) {
    super(props);

    this.questionTemplateFormRef = React.createRef();

    this.state = {
      modalOpen: false,
      saving: false,
    };

    this.onSaveStart = this.onSaveStart.bind(this);
    this.onSaved = this.onSaved.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.save = this.save.bind(this);
  }

  onSaveStart(){
    this.setState({
      saving: true
    });
  }

  onSaved(template){
    this.setState({
      modalOpen: false,
      saving: false,
    });

    this.props.onSaved(template);
  }

  toggleModal() {
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  save(){
    this.setState({
      saving: true
    });

    this.questionTemplateFormRef.current.save();
  }

  render() {
    const {modalOpen, saving} = this.state;

    return (
      <React.Fragment>
        <i className="fas fa-edit text-primary pointer mr-2" onClick={this.toggleModal} />
        {modalOpen && <Modal isOpen={modalOpen} toggle={this.toggleModal} size="lg">
          <ModalHeader toggle={this.toggleModal}>Edytuj szablon pytania</ModalHeader>
          <hr className="my-0" />
          <ModalBody>
            <QuestionTemplateForm
              ref={this.questionTemplateFormRef}
              onSaveStart={this.onSaveStart}
              onSaved={this.onSaved}
              template={{
                ...this.props.questionTemplate,
                tags: this.props.questionTemplate.tags.map(tag => tag.name),
              }}
            />
          </ModalBody>
          <ModalFooter>
            <FormattedMessage id="_.button.cancel">{
              (message) =>
                <Button color="secondary" className="mb-0" onClick={this.toggleModal}>{message}</Button>
            }</FormattedMessage>
            <FormattedMessage id="_.button.save">{
              (message) => <Button
                color="primary"
                loading={saving}
                onClick={this.save}
              >{message}</Button>
            }</FormattedMessage>
          </ModalFooter>
        </Modal>}
      </React.Fragment>
    );
  }
}

EditQuestionTemplate.propTypes = {
  onSaved: PropTypes.func.isRequired,
  questionTemplate: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default EditQuestionTemplate;